module.exports = __webpack_public_path__ + "media/images/flags/1x1/glp-7857d47cee1af035e9ec03644180ddf1.svg";